/**
 * Main(right) section of dashboard page
 */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Tooltip } from 'wix-style-react'

import Phone from '../shared/Phone'
// import Timeline from './Timeline'
import { getTemplateInfo } from 'templates/templates'
import { applyCustomFields } from 'controllers/logic'
import { media, TEAL, BLUE, GRAY } from '../styles'
import NextIcon from 'react-icons/lib/fa/arrow-right'

import emptyStateImage from 'assets/noTemplateSelected.png'

const Container = styled.div`
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  position: relative;
  ${media.small`font-size: 20px;`}
  ${media.huge`font-size: 26px;`}
  background-color: ${props => {
    if (props.isCardSelected && props.isApp) {
      return 'rgba(56, 153, 236, 0.07)'
    }
    if (props.isCardSelected && !props.isApp) {
      return 'rgba(131, 203, 202, 0.12)'
    }
  }};
`
const CenteredLayer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`
const PhoneContainer = styled.div`
  padding-top: 5px;
  width: 100%;
  height: calc(100% - 180px);

  > div {
    left: 0;
  }
`
const Image = styled.div`
  width: 100%;
  height: 100%;
  background: url('${props => props.image}') center / cover no-repeat;
`
const Footer = styled.div`
  width: 100%;
  height: 75px;
  margin-bottom: 1em;
  ${media.small`padding: 0 1em 0 1.5em;`}
  ${media.normal`padding: 0 1.5em 0 3em;`}

  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${props => props.isApp ? BLUE : TEAL};
  visibility: ${props => props.isCardSelected ? 'visible' : 'hidden'};
`
const TemplateDescription = styled.div`
  display: flex;
  align-items: center;
  color: #fff;
`
const Title = styled.div`
  font-size: 120%;
  font-weight: 600;
  margin-right: 1.7em;
  text-transform: capitalize;
  color: #fff;
`
const Category = styled.div`
  color: #fff;
  font-size: 60%;
  font-weight: 100;
`
const CustomButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;

  border: 3px solid #fff;
  padding: 12px 24px;
  border-radius: 10px;

  color: #fff;
  font-size: 20px;
  line-height: 1;
  font-weight: 400;

  cursor: pointer;

  &:hover {
    background-color: #fff;
    color: ${props => props.isApp ? BLUE : GRAY};
  }
`
const ButtonText = styled.div`
  margin-right: 9px;
`

const getInstantAppOfTemplate = (templateInfo) => (
  <templateInfo.instantApp settings={templateInfo.defaultSettings} showcaseMode />
)

const getInstantAppOfApplication = (appInfo) => {
  // console.log('appInfo', appInfo)
  const templateInfo = getTemplateInfo(appInfo.templateId)
  const settings = applyCustomFields(appInfo.customFields, templateInfo.defaultSettings)
  return <templateInfo.instantApp key={appInfo.id} settings={settings} showcaseMode />
}

class DashboardMain extends Component {

  render () {
    const { selectedCard = {}, createApp, editApp } = this.props
    const { title = '', category = '' } = selectedCard
    const isCardSelected = 'id' in selectedCard
    const isApp = 'published' in selectedCard // Is app card, otherwise template card

    return (
      <Container isCardSelected={isCardSelected} isApp={isApp}>
        <CenteredLayer>
          {/* <Timeline isVisible={isCardSelected && !isApp} /> */}
          <Footer isCardSelected={isCardSelected} isApp={isApp}>
            <TemplateDescription>
              <Title>{title}</Title>
              {!isApp && <Category>{category}</Category>}
            </TemplateDescription>
            {isCardSelected &&
              <Tooltip
                content={<div>Click to select this template<br />and create your app.</div>}
                showTrigger='custom'
                onClickOutside={null}
                onShow={null}
                placement='bottom'
                bounce
                active
                showDelay={4000}
                shouldCloseOnClickOutside
                moveBy={{x: 0, y: 25}}
                disabled={isApp}
              >
                <CustomButton isApp={isApp} onClick={isApp ? editApp : createApp}>
                  <ButtonText>{isApp ? 'Edit' : 'Next Step'}</ButtonText> <NextIcon />
                </CustomButton>
              </Tooltip>
            }
          </Footer>
          <Tooltip
            content='Live preview this template.  Click, swipe on it normally.'
            placement='bottom'
            moveBy={{ x: 0, y: -60 }}
            size='large'
            onClickOutside={null}
            onShow={function noRefCheck () {}}
            shouldCloseOnClickOutside
            bounce
            showDelay={300}
            hideDelay={500}
          >
            <PhoneContainer>
              <Phone>
                {(isCardSelected)
                  ? (isApp)
                    ? getInstantAppOfApplication(selectedCard)
                    : getInstantAppOfTemplate(selectedCard)
                  : <Image image={emptyStateImage} />
                }
              </Phone>
            </PhoneContainer>
          </Tooltip>
        </CenteredLayer>
      </Container>
    )
  }
}

DashboardMain.propTypes = {
  selectedCard: PropTypes.object,
  createApp: PropTypes.func.isRequired,
  editApp: PropTypes.func.isRequired,
}

export default DashboardMain



// WEBPACK FOOTER //
// ./src/components/dashboard/DashboardMain.js